import { SettingsProvider } from "@/components/settings";
import { SnackbarProvider } from "@/components/snackbar";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ChatProvider } from "@/contexts/ChatContext";
import { useWebSocketClient, WebSocketProvider } from "@/contexts/WebSocketContext";
import { getApiUrl, getStoredAuth } from "@/lib/auth-utils";
import { getPageId } from "@/services/utl-service";
import ThemeProvider from "@/theme";
import { SpreeThemeProvider } from "@/theme/spree";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ReactNode, useCallback, useMemo } from "react";
import BlockedCustomerAlertListener from "@/components/customers/BlockedCustomerAlertListener";
import { AuthProvider } from "../contexts/AuthContext";

interface AllProvidersProps {
  children: ReactNode;
}

export default function AllProviders({ children }: AllProvidersProps) {

  const baseUrl = getApiUrl();
  const { accessToken } = getStoredAuth();
  const pageId = useMemo(() => (accessToken ? getPageId() : null), [accessToken]);
  const enabled = Boolean(accessToken && pageId);

  // Optional: keep onConnected just for logging / reset counters
  const onWebsocketConnect = useCallback(() => {
    console.log("WebSocket connected", { pageId, enabled });
    // stable handlers


  }, [pageId, accessToken])
  return (
    <AuthProvider>
      <SettingsProvider
        defaultSettings={{
          themeMode: "light", // 'light' | 'dark'
          themeDirection: "ltr", //  'rtl' | 'ltr'
          themeContrast: "default", // 'default' | 'bold'
          themeLayout: "vertical", // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: "default", // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: true,
        }}
      >
        <ThemeProvider>
          <SpreeThemeProvider>

            <ChatProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TooltipProvider>
                  <SnackbarProvider>
                    <Toaster />

                    <WebSocketProvider baseUrl={baseUrl} token={accessToken} onConnected={onWebsocketConnect}>
                      <BlockedCustomerAlertListener />
                      {children}
                    </WebSocketProvider>
                  </SnackbarProvider>
                </TooltipProvider>
              </LocalizationProvider>
            </ChatProvider>
          </SpreeThemeProvider>
        </ThemeProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
